@let dataValue = data();
@if (bulkMode()) {
    <button class="button listingCountButton action-button" type="button" (click)="triggerBulkOpenListingList()">
        <i class="far fa-arrow-up-right-from-square"></i>
        <span>{{ 'listings.bulk.header.numberOfListings' | translate: { count: bulkListingCount() ?? '-' } }}</span>
    </button>
    <button
        class="button primary saveAndActivateBtn action-button"
        type="button"
        (click)="triggerBulkSaveAndActivate()"
        *appPermission="'listings.saveOptions'"
    >
        <i class="far fa-save"></i>
        <span>{{ 'generalKeywords.save' | translate }}</span>
    </button>
} @else if (listing()) {
    @if (dataValue.showPublishing) {
        <button class="button with-loader action-button" type="button" [disabled]="dataValue.disableActions">
            <app-loader type="spinner" [alwaysShow]="true"></app-loader> {{ 'listings.header.publishingInProgress' | translate }}
        </button>
    }

    @if (listingValidationService.hasErrors()) {
        @let contentErrorsCount = listingValidationService.contentErrors().length;
        @let visualErrorsCount = listingValidationService.visualErrors().length;
        @let totalErrors = contentErrorsCount + visualErrorsCount;
        <div
            class="validationFailures"
            role="status"
            aria-live="polite"
            tabindex="0"
            appTooltip
            trigger="hover"
            [component]="$any(validationErrorsTooltip)"
            [componentData]="{}"
            position="right"
            [showDelay]="200"
            [hideDelay]="200"
        >
            <div class="bannerContent">
                <span class="bannerTitle">
                    {{ 'listing.validationIssues.validationErrorsMessage' | translate: { total: totalErrors } }}
                </span>
                <span class="bannerBreakdown">
                    <span class="breakdownItem" [class.empty]="contentErrorsCount === 0">
                        <i class="fas fa-file-lines" aria-hidden="true"></i>
                        <span>{{ 'listing.validationIssues.categoryContent' | translate }}</span>
                        <strong>{{ contentErrorsCount }}</strong>
                    </span>
                    <span class="breakdownSeparator" aria-hidden="true">/</span>
                    <span class="breakdownItem" [class.empty]="visualErrorsCount === 0">
                        <i class="fas fa-image" aria-hidden="true"></i>
                        <span>{{ 'listing.validationIssues.categoryVisuals' | translate }}</span>
                        <strong>{{ visualErrorsCount }}</strong>
                    </span>
                </span>
            </div>
            <i class="bannerCaret fas fa-chevron-right" aria-hidden="true"></i>
        </div>
    }

    @if (dataValue.showMenu) {
        <app-menu #userMenu class="userMenu" [positioning]="['bottom', 'left']" [disabled]="dataValue.disableActions">
            <button class="button moreOptionsButton action-button" [disabled]="dataValue.disableActions" type="button" menuActivator>
                <i class="far fa-ellipsis-vertical"></i>
                {{ 'listing.moreOptions' | translate }}
            </button>
            <ul class="menuList">
                @if (dataValue.showStartVersionComparison) {
                    <li class="menuItem primary" (click)="!dataValue.disableActions && openVersionComparisonModal()">
                        <i class="far fa-eye"></i>
                        {{ 'listing.version.seeChanges' | translate }}
                    </li>
                }
                @if (dataValue.showExitComparison) {
                    <li class="menuItem primary" (click)="!dataValue.disableActions && exitComparison()">
                        <i class="far fa-arrow-left"></i>
                        {{ 'listing.version.backToEditMode' | translate }}
                    </li>
                }
                @if (dataValue.showDelete) {
                    <li
                        class="menuItem danger"
                        (click)="!dataValue.disableActions && (forRoom() ? deleteRoom() : forOutlet() ? deleteOutlet() : deleteListing())"
                        *appPermission="forOutlet() ? 'listings.outletDelete' : 'listings.delete'"
                    >
                        <i class="far fa-trash"></i> {{ 'listings.header.delete' | translate }}
                    </li>
                }
                @if (dataValue.showUserPreferences) {
                    <li class="menuItem" (click)="!dataValue.disableActions && openUserPreferencesDrawer()">
                        <i class="far fa-sliders-simple"></i>
                        {{ 'listings.header.userPreferences' | translate }}
                    </li>
                }
            </ul>
        </app-menu>
    }

    @if (dataValue.showSavingOptions) {
        <button
            class="button primary saveAndActivateBtn action-button"
            type="button"
            (click)="openSavingOptionsModal()"
            *appPermission="'listings.saveOptions'"
        >
            @if (dataValue.allPartsLive) {
                <i class="far fa-plus"></i> {{ 'listing.createDraft' | translate }}
            } @else {
                <i class="far fa-save"></i> {{ 'listings.header.saveAndActivate' | translate }}
            }
        </button>
    }
}
